import { render, staticRenderFns } from "./hk-access-money.vue?vue&type=template&id=07cf54ea&scoped=true&"
import script from "./hk-access-money.vue?vue&type=script&lang=js&"
export * from "./hk-access-money.vue?vue&type=script&lang=js&"
import style0 from "./hk-access-money.vue?vue&type=style&index=0&id=07cf54ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07cf54ea",
  null
  
)

export default component.exports